import * as Yup from 'yup';

interface ShareCapital {
  readonly value?: number;
  readonly currencyId?: string;
}

export const ShareCapitalSchema = Yup.object()
  .shape({
    value: Yup.number().moreThan(0, 'Le capital social doit être positif'),
    currencyId: Yup.string(),
  })
  .test({
    name: 'share-capital',
    message: 'Le capital social doit être complet ou vide',
    test: (shareCapital?: ShareCapital) =>
      !(
        (!!shareCapital?.currencyId &&
          !shareCapital.value &&
          shareCapital.value !== 0) ||
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        (!shareCapital?.currencyId && shareCapital?.value) ||
        shareCapital?.value === 0
      ),
  });
